import { BadgeProps } from '@razorpay/blade/components';
import styled from 'styled-components';

export const EventTimestampWrapper = styled.div<{ borderColor?: BadgeProps['color'] }>(
  ({ theme, borderColor }) => {
    return `
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing[1]}px;
        padding-left: ${theme.spacing[3]}px;
        padding-right: ${theme.spacing[3]}px;
        border-left: ${
          borderColor
            ? `${theme.border.width.thicker}px solid ${theme.colors.interactive.border[borderColor].default}`
            : 'none'
        };
    `;
  },
);

export const StyledPayrollProgressWrapper = styled.div(
  ({ theme }) => `
        background-color: ${theme.colors.interactive.background.gray.faded};
        border: ${theme.border.width.thinner}px solid ${theme.colors.surface.border.gray.muted};
        border-radius: ${theme.border.radius.medium}px;
        padding: ${theme.spacing[5]}px 0px 0px;
        overflow: hidden;
        margin-bottom: ${theme.spacing[7]}px;
    `,
);

export const StyledActionSummaryWrapper = styled.div(
  ({ theme }) => `
    background-color: ${theme.colors.surface.background.gray.intense};
    border-color: ${theme.colors.surface.border.gray.subtle};
    border-style: solid;
    border-width: ${theme.border.width.thin}px;
    border-left: none;
    border-top-right-radius: ${theme.border.radius.large}px;
    border-bottom-right-radius: ${theme.border.radius.large}px;
    padding: ${theme.spacing[5]}px;
    flex: 1;
  `,
);

export const ResetLocalOverridingStyles = styled.div`
  button {
    height: unset;
  }
  td {
    border-bottom: unset;
  }
  th:first-child {
    padding-left: unset;
  }
  td:first-child {
    padding-left: unset;
  }
  .wrapper__opfin-url input#subdomain, .wrapper__opfin-url input#subdomain span.underline, .wrapper__opfin-url p, .wrapper__opfin-url p span.underline, .wrapper__opfin-url p span.underline span.underline, h3, h3 span.underline, p{
    max-width: unset;
  }
`;
